import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { AndresB_Video1 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoAndres1 = () => {
  return (
    <>
      <ModalVideo
        id="andres-video-1"
        dataText={AndresB_Video1}
        videoSrc="https://www.youtube.com/embed/b2Og_slH1rE?si=Z7X4r4HkVm8Z_v1m"
        videoTitle="KUTER_STUDIO_AI_ANDRES_VIDEO_1"
      />
    </>
  );
};

export default ModalVideoAndres1;
